<template>
  <OnexSelect
    class="py-2"
    max-width="200"
    v-model="currentPreference"
    :items="getLanguagePrefs"
    :label="$t('')"
    :menu-props="{ location: 'bottom center', scrollStrategy: 'close' }"
  ></OnexSelect>
</template>
<script lang="ts">
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions, mapState } from 'pinia';
import { OnexButton, OnexSelect } from '@primerica/onex-ui-lib';
import { type ComponentOptions, defineComponent } from 'vue';
import { LOCALES, COUNTRIES } from '@/shared/models/constants.models';
import { UILocale } from '@/shared';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useI18n } from 'vue-i18n';

const componentOptions: ComponentOptions = {
  name: 'LocaleSelector',
  setup() {
    const { locale } = useI18n();
    const selectedLanguage = locale.value;

    const changeLanguage = (newLocale: string) => {
      // en-US en_US
      newLocale = newLocale.replace('_', '-');
      locale.value = newLocale;
    };

    return {
      selectedLanguage,
      changeLanguage,
    };
  },
  components: {
    OnexButton,
    OnexSelect,
    UILocale,
  },
  props: {
    showNotificationDetail: {
      type: Boolean,
      default: false,
    },
    notificationId: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      languagesPrefs: window.appConfig.languagePreferences,
      languages: [] as LOCALES[],
      currentPreference: '' as string,
    };
  },
  watch: {
    currentPreference(newVal: string, oldVal: string) {
      if (newVal !== oldVal && oldVal !== '') {
        this.changeLanguage(newVal);
        const swapDashWithUnderscore = newVal.replace('-', '_');
        // If the user has a country set in their profile, update the language preference via API. Otherwise, update it locally for pre-auth users.
        if (this.customerProfile?.country) {
          this.updateLanguagePreference(swapDashWithUnderscore);
        } else {
          // pre-auth: update store locally without API call since we don't know the user's country yet
          this.changeLocalePreLogin(swapDashWithUnderscore);
        }
      }
    },
  },

  computed: {
    ...mapState(useGlobalStore, {
      locale: 'locale',
      alertsAndNotifications: 'alertsAndNotifications',
    }),
    ...mapState(useCustomerStore, ['customerProfile']),
    getLanguagePrefs() {
      if (!this.isCanadian) {
        return [
          { title: 'English (US)', value: 'en-US' },
          //   { title: 'Español (US)', value: 'es-US' },
        ];
      } else {
        return [
          { title: 'English (CAN)', value: 'en-CA' },
          { title: 'French (CAN)', value: 'fr-CA' },
        ];
      }
    },
    isCanadian() {
      return this.customerProfile?.country === COUNTRIES.CANADA;
    },
  },
  methods: {
    ...mapActions(useGlobalStore, [
      'getAlerts',
      'dismissAlert',
      'completeAlert',
      'changeLocale',
      'updateLocale',
      'updateLanguagePreference',
      'changeLocalePreLogin',
    ]),
  },
  mounted() {
    if (this.isCanadian && this.selectedLanguage === 'en_US') {
      this.currentPreference = 'en_CA';
    } else if (this.isCanadian && this.selectedLanguage === 'es_US') {
      this.currentPreference = 'en_CA';
    } else if (!this.isCanadian && this.selectedLanguage === 'en_CA') {
      this.currentPreference = 'en_US';
    } else if (!this.isCanadian && this.selectedLanguage === 'fr_CA') {
      this.currentPreference = 'en_US';
    } else {
      this.currentPreference = this.selectedLanguage;
    }
  },
};
export default defineComponent(componentOptions);
</script>
